(function () {
  'use strict';

  // Bail out if Shopify analytics isn't available
  if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') {
    return;
  }

  var MAX_ANCESTOR_DEPTH = 10;
  var MAX_TEXT_LENGTH = 200;

  /**
   * Walk up the DOM tree (up to MAX_ANCESTOR_DEPTH levels) looking for
   * the nearest ancestor with an id attribute.
   */
  function findNearestId(el) {
    var current = el;
    var depth = 0;

    while (current && depth <= MAX_ANCESTOR_DEPTH) {
      if (current.id) {
        return { id: current.id, source: depth === 0 ? 'self' : 'ancestor', distance: depth };
      }
      current = current.parentElement;
      depth++;
    }

    return { id: '', source: 'none', distance: null };
  }

  /**
   * Build a CSS-selector-ish fallback path when no id is found.
   * e.g. "div.hero > ul.nav > li > a.btn"
   */
  function buildFallbackPath(el) {
    var parts = [];
    var current = el;
    var depth = 0;

    while (current && current !== document.body && depth <= MAX_ANCESTOR_DEPTH) {
      var tag = current.tagName.toLowerCase();
      var classes = current.className && typeof current.className === 'string'
        ? '.' + current.className.trim().split(/\s+/).join('.')
        : '';
      parts.unshift(tag + classes);
      current = current.parentElement;
      depth++;
    }

    return parts.join(' > ');
  }

  /**
   * Find the nearest <a> ancestor (or the element itself if it's a link).
   */
  function findNearestLink(el) {
    var current = el;
    while (current && current !== document.body) {
      if (current.tagName === 'A') return current;
      current = current.parentElement;
    }
    return null;
  }

  /**
   * Get visible text content, trimmed and capped.
   */
  function getVisibleText(el) {
    if (!el) return '';
    var text = (el.innerText || el.textContent || '').trim();
    return text.length > MAX_TEXT_LENGTH ? text.substring(0, MAX_TEXT_LENGTH) : text;
  }

  /**
   * Determine if a URL is outbound (different hostname).
   */
  function isOutbound(url) {
    if (!url) return false;
    try {
      var linkHost = new URL(url, window.location.origin).hostname;
      return linkHost !== window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  /**
   * Extract hostname from a URL string.
   */
  function getDomain(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).hostname;
    } catch (e) {
      return '';
    }
  }

  // Capture-phase listener so we fire before stopPropagation() calls
  document.addEventListener('click', function (event) {
    var clicked = event.target;
    if (!clicked || !clicked.tagName) return;

    var link = findNearestLink(clicked);
    var idInfo = findNearestId(clicked);
    var linkUrl = link ? link.href : '';

    var payload = {
      link_id: link ? (link.id || '') : (clicked.id || ''),
      link_classes: link ? (link.className || '') : '',
      link_url: linkUrl,
      link_domain: getDomain(linkUrl),
      link_text: link ? getVisibleText(link) : '',
      outbound: isOutbound(linkUrl),

      click_tag_name: clicked.tagName,
      click_input_type: clicked.type || '',
      click_text: getVisibleText(clicked),

      click_id: idInfo.id,
      click_id_source: idInfo.source,
      click_id_distance: idInfo.distance,
      click_id_fallback_path: idInfo.source === 'none' ? buildFallbackPath(clicked) : null
    };

    window.Shopify.analytics.publish('custom_click', payload);
  }, true);
})();
